var map = {
	"./AINSWORTH.png": "4c23",
	"./AMATIC.png": "4828",
	"./APEX.png": "fa37",
	"./APOLLO.png": "b995",
	"./ARISTOCRAT.png": "d1ad",
	"./EGT.png": "1fdb",
	"./GCLUB.png": "a457",
	"./IGROSOFT.png": "f6a4",
	"./IGT.png": "534f",
	"./MICROGAMING.png": "d48f",
	"./NETENT.png": "4288",
	"./NOVOMATIC.png": "ec57",
	"./PRAGMATIC.png": "6500",
	"./QUICKSPIN.png": "6e59",
	"./SCIENTIFIC_GAMES.png": "b6ab",
	"./VEGAS.png": "f303",
	"./WAZDAN.png": "3804",
	"./logo/slot_a1_ainsworth.png": "7449",
	"./logo/slot_a1_amatic.png": "6425",
	"./logo/slot_a1_apex.png": "6573",
	"./logo/slot_a1_apollo.png": "2a41",
	"./logo/slot_a1_aristocrat.png": "9df0",
	"./logo/slot_a1_egt.png": "44d2",
	"./logo/slot_a1_gclub.png": "2283",
	"./logo/slot_a1_igrosoft.png": "cbbd",
	"./logo/slot_a1_igt.png": "38da",
	"./logo/slot_a1_microgaming.png": "69c0",
	"./logo/slot_a1_netent.png": "c423",
	"./logo/slot_a1_novomatic.png": "374a",
	"./logo/slot_a1_pragmatic.png": "778d",
	"./logo/slot_a1_quickspin.png": "651b",
	"./logo/slot_a1_scientific_games.png": "db03",
	"./logo/slot_a1_vegas.png": "ceed",
	"./logo/slot_a1_wazdan.png": "4b7b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e2ce";